import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {DxDataGridComponent} from "devextreme-angular/ui/data-grid";
import {FacturationClientService} from "../../../core/services/entities/facturation-client.service";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../core/utils/utils.service";
import {AnalyseFinanciereDetail} from "../../../core/models/facturation/client/analyse-financiere-detail";
import {AnalyseFinanciere} from "../../../core/models/facturation/client/analyse-financiere";
import {TypeExportAnalyseFinanciere} from "../../../core/enums/facturation/client/type-export-analyse-financiere";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";

@Component({
    templateUrl: './tableau-de-bord.component.html',
    styleUrls: ['./tableau-de-bord.component.scss'],
    standalone: false
})

export class TableauDeBordComponent implements OnInit, OnDestroy {
  @ViewChild('gridPrestation') gridPrestation: DxDataGridComponent;
  @ViewChild('gridFamilleProduit') gridFamilleProduit: DxDataGridComponent;
  @ViewChild('gridPlat') gridPlat: DxDataGridComponent;

  currentIndex: number = 0;
  subExport: Subscription;

  analyseFinancierePlat: AnalyseFinanciereDetail[] = [];
  analyseFinancierePrestation: AnalyseFinanciereDetail[] = [];
  analyseFinanciereFamilleProduit: AnalyseFinanciereDetail[] = [];

  constructor(public facturationClientSvc: FacturationClientService, private utilSvc: UtilsService) {}

  ngOnInit(): void {
    this.initData();
    this.initSubExport();
  }

  ngOnDestroy(): void {
    this.utilSvc.unsubscribe(this.subExport);
  }

  initSubExport = (): void => {

    this.subExport = this.facturationClientSvc.exportAnalyseFinanciere$.subscribe((result: AnalyseFinanciere) => {
      if (result) {
        const type: TypeExportAnalyseFinanciere = result.type;
        const details: AnalyseFinanciereDetail[] = result.details;
        switch (type) {
          case TypeExportAnalyseFinanciere.PRESTATION:
            this.currentIndex = 0;
            this.analyseFinancierePrestation = details;
            this.facturationClientSvc.dataAnalysePrestation = details;
            break;
          case TypeExportAnalyseFinanciere.PLAT:
            this.currentIndex = 2;
            this.analyseFinancierePlat = details;
            this.facturationClientSvc.dataAnalysePlat = details;
            break;
          case TypeExportAnalyseFinanciere.FAMILLE_PRODUIT:
            this.currentIndex = 1;
            this.analyseFinanciereFamilleProduit = details;
            this.facturationClientSvc.dataAnalyseFamilleProduit = details;
            break;
        }
      }
    });
  }

  displayExportSettings(currentIndex: number): void {
    this.facturationClientSvc.announceOpenExportSettings(currentIndex);
  }

  private initData(): void {
    this.analyseFinancierePlat = this.facturationClientSvc.dataAnalysePlat;
    this.analyseFinancierePrestation = this.facturationClientSvc.dataAnalysePrestation;
    this.analyseFinanciereFamilleProduit = this.facturationClientSvc.dataAnalyseFamilleProduit;
  }

  updateSelectedIndex(newValue: number): void {
    this.currentIndex = newValue;
  }

  expandOptions = (grid: () => DxDataGridComponent) => ({ icon: 'fas fa-expand-alt', hint: 'Étendre tous les éléments du tableau', onClick: () => grid()?.instance.expandAll() });
  collapseOptions = (grid: () => DxDataGridComponent) => ({ icon: 'fas fa-compress-alt', hint: 'Réduire tous les éléments du tableau', onClick: () => grid()?.instance.collapseAll() });

  expandPrestationOptions = this.expandOptions(() => this.gridPrestation);
  collapsePrestationOptions = this.collapseOptions(() => this.gridPrestation);
  expandFamilleProduitOptions = this.expandOptions(() => this.gridFamilleProduit);
  collapseFamilleProduitOptions = this.collapseOptions(() => this.gridFamilleProduit);
  expandPlatOptions = this.expandOptions(() => this.gridPlat);
  collapsePlatOptions = this.collapseOptions(() => this.gridPlat);

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
